import { type ActionItem } from 'shared/ui'
import { type SurveyRow } from 'entities/Surveys/model/Table/SurveyRow'
import { deleteSurvey } from 'pages/surveys/ui/actions/deleteSurvey/deleteSurvey'
import { editSurvey } from './editSurvey/editSurvey'
import { detailsSurvey } from './detailsSurvey/detailsSurvey'
import { duplicate } from './duplicate/duplicate'

export const getSurveyRowActions = (
  item: SurveyRow,
  onDeleteItem: (id: number) => void
): ActionItem[] => {
  return [
    editSurvey(item.id),
    detailsSurvey(item.data),
    duplicate(item.id),
    deleteSurvey(item.id, onDeleteItem),
  ]
}
